import { authService } from '../../services/auth/authService';
import type { FirebaseLoginResult } from '../../entities/auth/firebaseLoginResult';

/**
 * SignInWithAppleUseCase
 *
 * Runs the Apple Sign-In popup and returns the raw FirebaseLoginResult.
 * Mirrors Flutter's two-step login shape: the caller of this use case is
 * responsible for calling `SaveUserUseCase` next (see
 * `lib/presentation/screens/login/login_screen.dart:_login` lines 97-159).
 */
export class SignInWithAppleUseCase {
    async execute(): Promise<FirebaseLoginResult> {
        return await authService.signInWithApple();
    }
}

export const signInWithAppleUseCase = new SignInWithAppleUseCase();
